var map = {
	"./account-icon.svg": "6f47",
	"./account-setting-icon.svg": "9ee2",
	"./ax-icon.svg": "60cc",
	"./close-icon.svg": "d144",
	"./closebtn-icon.svg": "a9f7",
	"./config-account-icon.svg": "2bf9",
	"./dark-mode-icon.svg": "31cb",
	"./document-icon.svg": "6647",
	"./download-icon.svg": "8d12",
	"./folios-icon.svg": "6ca4",
	"./help-icon.svg": "da59",
	"./home-icon.svg": "3177",
	"./metrics-icon.svg": "7819",
	"./open-icon.svg": "eb57",
	"./pos-icon.svg": "e602",
	"./product-compliance/issue-icon.svg": "9c55",
	"./product-compliance/operation-icon.svg": "2629",
	"./product-compliance/process-icon.svg": "b67d",
	"./product-compliance/sire-icon.svg": "7d20",
	"./product-compliance/task-manager-icon.svg": "b46b",
	"./product-documents/customer-icon.svg": "3478",
	"./product-documents/dashboard-icon.svg": "c7fd",
	"./product-documents/document-icon.svg": "2009",
	"./product-documents/fl-icon.svg": "2b74",
	"./product-documents/folios-icon.svg": "2860",
	"./product-documents/home-icon.svg": "f34c",
	"./product-documents/portal-icon.svg": "34ea",
	"./product-documents/purchase-icon.svg": "f555",
	"./product-documents/report-icon.svg": "4f75",
	"./product-folios/branch-icon.svg": "21d8",
	"./product-folios/folios-icon.svg": "f93b",
	"./product-folios/groups-icon.svg": "f64a",
	"./product-folios/logs-icon.svg": "0dc5",
	"./product-folios/monitor-icon.svg": "05f7",
	"./product-folios/pos-icon.svg": "3dc8",
	"./product-folios/rollout-icon.svg": "fd1f",
	"./product-holdings/audit-icon.svg": "ba92",
	"./product-holdings/certificates-icon.svg": "d966",
	"./product-holdings/organizations-icon.svg": "c0e7",
	"./product-holdings/orgunits-icon.svg": "2c7e",
	"./product-holdings/users-icon.svg": "8eea",
	"./product-insight/insight-icon.svg": "9237",
	"./product-outbound/home-icon.svg": "a71c",
	"./product-outbound/portal-icon.svg": "ac2a",
	"./product-outbound/report-icon.svg": "ce30",
	"./product-outbound/template-icon.svg": "f033",
	"./product-outbound/tracker-icon.svg": "7703",
	"./product-pos/branch-icon.svg": "4347",
	"./product-pos/groups-icon.svg": "11c9",
	"./product-pos/logs-icon.svg": "eb20",
	"./product-pos/monitor-icon.svg": "c933",
	"./product-pos/pos-icon.svg": "1ebd",
	"./product-pos/report-icon.svg": "33d5",
	"./product-pos/rollout-icon.svg": "99a4",
	"./product-purchase/automation-icon.svg": "fc3f",
	"./product-purchase/claim-icon.svg": "05c1",
	"./product-purchase/customer-icon.svg": "9fbf",
	"./product-purchase/dashboard-icon.svg": "3318",
	"./product-purchase/fl-icon.svg": "cdc2",
	"./product-purchase/folios-icon.svg": "ca07",
	"./product-purchase/home-icon.svg": "7507",
	"./product-purchase/portal-icon.svg": "1502",
	"./product-purchase/purchase-icon.svg": "6458",
	"./product-purchase/report-icon.svg": "be58",
	"./purchase-icon.svg": "8a00",
	"./report-icon.svg": "2957"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5035";